<template>
	<transition
			name="custom-classes-transition" 
			:enter-active-class="$_mbFtr_styleComponentAnimation()">
		<template v-if="$_mbFtr_stateComponentIsInitialized && $_mbFtr_stateComponentShowMessagebarFooter">
			<v-footer
					:class="env.dev || env.qa ? 'footer_' : ''"

					app
					height="auto"
					
					:color="$_mbFtr_styleFooterColor"
					:dark="$_mbFtr_styleFooterDark"
					:light="$_mbFtr_styleFooterLight">
				<v-row align="center" justify="end" dense>
					<v-col cols="12" md="8">
						<v-row	align="center"
								:justify="$_mbFtr_stateAppIsMobileScreen ? 'start' : 'end'"
								dense>
							<!-- close button -->
							<template v-if="$_mbFtr_stateAppIsMobileScreen">
								<v-col cols="12" class="center">
									<v-btn	class="customVBtn"
											icon
											small
											@click="$_mbFtr_close()">
										<v-icon>expand_more</v-icon>
									</v-btn>
								</v-col>
							</template>
							<template v-else>
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											icon
											@click="$_mbFtr_close()">
										<v-icon>highlight_off</v-icon>
									</v-btn>
								</v-col>
								<v-spacer />
								<!-- chat -->
								<v-col cols="auto">
									<messagebar-chat-dialog />
								</v-col>
								<!-- to -->
								<v-col cols="auto">
									<messagebar-to-dialog />
								</v-col>
								<!-- title -->
								<v-col cols="auto">
									<messagebar-title-dialog />
								</v-col>
								<!-- attachment -->
								<v-col cols="auto">
									<messagebar-attachment-dialog />
								</v-col>
								<!-- tag -->
								<v-col cols="auto">
									<messagebar-tag-dialog />
								</v-col>
							</template>
						</v-row>
					</v-col>
					<!-- message text -->
					<v-col xs="12" md="4">
						<validation-observer v-slot="validation">
							<v-form>
								<v-row dense align="center">
									<v-col>
										<validation-provider rules="required">
											<v-textarea
													class="customVTextarea"

													hide-details

													v-model="messageState_.text"
													
													:auto-grow="$_mbFtr_styleTextareaAutoGrow"
													:background-color="$_mbFtr_styleTextareaBackgroundColor"
													:clearable="$_mbFtr_styleTextareaClearable"
													:color="$_mbFtr_styleTextareaColor"
													:counter="$_mbFtr_styleTextareaCounter"
													:dark="$_mbFtr_styleTextareaDark"
													:filled="$_mbFtr_styleTextareaFilled"
													:flat="$_mbFtr_styleTextareaFlat"
													:light="$_mbFtr_styleTextareaLight"
													:outlined="$_mbFtr_styleTextareaOutlined"
													:rows="$_mbFtr_styleTextareaRows"
													:solo="$_mbFtr_styleTextareaSolo"
													:solo-inverted="$_mbFtr_styleTextareaSoloInverted"
													
													placeholder="Send Message" />
										</validation-provider>
									</v-col>
									<v-col cols="auto">
										<v-btn	class="customVBtn"
												:disabled="!validation.passed && !validation.valid"
												icon
												@click="$_mbFtr_send()">
											<template v-if="isFalse(onSending_)">
												<v-icon>send</v-icon>
											</template>
											<template v-else>
												<progress-circular />
											</template>
										</v-btn>
									</v-col>
								</v-row>
							</v-form>
						</validation-observer>
					</v-col>
				</v-row>
			</v-footer>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'MessagebarFooter',
		data() {
			return {
				componentName_: 'messagebarFooter',

				valid_: true,

				messageState_: {},

				onSending_: false
			}
		},
		computed: {
			// current user
			$_mbFtr_currentUser() {
				const self_ = this;
				return self_.getCurrentUser()
			},
			// state
			$_mbFtr_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_mbFtr_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			$_mbFtr_stateComponentShowMessagebarFooter() {
				const self_ = this;
				return self_.getComponentState('showMessagebarFooter')
			},
			$_mbFtr_statePageName() {
				const self_ = this;
				return self_.getPageState('name')
			},
			// contents / inits
			$_mbFtr_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_mbFtr_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// page info
			$_mbFtr_pageInits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.$_mbFtr_statePageName)
				}
			},
			$_mbFtr_infoPageContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_mbFtr_pageInits(), 'contact')
			},
			$_mbFtr_infoPageContactFullName() {
				const self_ = this;
				const contact_ = self_.$_mbFtr_infoPageContact;
				if(self_.isEmpty(contact_)) { return null }
				return contact_.fullName
			},
			$_mbFtr_infoPageContactUid() {
				const self_ = this;
				const contact_ = self_.$_mbFtr_infoPageContact;
				if(self_.isEmpty(contact_)) { return null }
				return contact_.uid
			},
			// lang
			$_mbFtr_langVerifyButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'verifyButton')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langOtp() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'otp')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langOtpHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'otpHint')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langOtpMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'otpMask')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langOtpMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'otpMessage')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langOtpPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'otpPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langOtpPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'otpPrefix')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langOtpSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'otpSuffix')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langOtpType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'otpType')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langPhone() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'phone')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langPhoneHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'phoneHint')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langPhoneMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'phoneMask')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langPhoneMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'phoneMessage')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langPhonePlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'phonePlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langPhonePrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'phonePrefix')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langPhoneSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'phoneSuffix')
				return self_.getLangsVal(lang_)
			},
			$_mbFtr_langPhoneType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_mbFtr_inits(), 'phoneType')
				return self_.getLangsVal(lang_)
			},
			// style
			$_mbFtr_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_mbFtr_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_mbFtr_inits(), 'component')
				}
			},
			$_mbFtr_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_mbFtr_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_mbFtr_styleFooter() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mbFtr_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mbFtr_inits(), 'footer')
			},
			$_mbFtr_styleFooterColor() {
				const self_ = this;
				const footer_ = self_.$_mbFtr_styleFooter;
				if(self_.isFalse(footer_)) { return null }
				return self_.getStylesVal(footer_.color)
			},
			$_mbFtr_styleFooterDark() {
				const self_ = this;
				const footer_ = self_.$_mbFtr_styleFooter;
				if(self_.isFalse(footer_)) { return null }
				return self_.getStylesVal(footer_.dark)
			},
			$_mbFtr_styleFooterLight() {
				const self_ = this;
				const footer_ = self_.$_mbFtr_styleFooter;
				if(self_.isFalse(footer_)) { return null }
				return self_.getStylesVal(footer_.light)
			},
			$_mbFtr_styleTextarea() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_mbFtr_inits(), 'textarea')
			},
			$_mbFtr_styleTextareaAutoGrow() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.autoGrow)
			},
			$_mbFtr_styleTextareaBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_mbFtr_styleTextareaClearable() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_mbFtr_styleTextareaColor() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_mbFtr_styleTextareaCounter() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.counter)
			},
			$_mbFtr_styleTextareaDark() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_mbFtr_styleTextareaFilled() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_mbFtr_styleTextareaFlat() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_mbFtr_styleTextareaLight() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_mbFtr_styleTextareaOutlined() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_mbFtr_styleTextareaRows() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.rows)
			},
			$_mbFtr_styleTextareaSolo() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_mbFtr_styleTextareaSoloInverted() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextarea;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_mbFtr_styleTextField() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mbFtr_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mbFtr_inits(), 'textField')
			},
			$_mbFtr_styleTextFieldAppendIcon() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.appendIcon)
			},
			$_mbFtr_styleTextFieldAppendOuterIcon() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.appendOuterIcon)
			},
			$_mbFtr_styleTextFieldBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_mbFtr_styleTextFieldClearable() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_mbFtr_styleTextFieldColor() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_mbFtr_styleTextFieldCounter() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.counter)
			},
			$_mbFtr_styleTextFieldDark() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_mbFtr_styleTextFieldFilled() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_mbFtr_styleTextFieldFlat() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_mbFtr_styleTextFieldLight() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_mbFtr_styleTextFieldOutlined() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_mbFtr_styleTextFieldPrependIcon() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.prependIcon)
			},
			$_mbFtr_styleTextFieldPrependInnerIcon() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.prependInnerIcon)
			},
			$_mbFtr_styleTextFieldSolo() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_mbFtr_styleTextFieldSoloInverted() {
				const self_ = this;
				const style_ = self_.$_mbFtr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_mbFtr_styleActionButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mbFtr_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mbFtr_inits(), 'actionButton')
			},
			$_mbFtr_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_mbFtr_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_mbFtr_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ = self_.$_mbFtr_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_mbFtr_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_mbFtr_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_mbFtr_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_mbFtr_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_mbFtr_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_mbFtr_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_mbFtr_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_mbFtr_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_mbFtr_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_mbFtr_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_mbFtr_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_mbFtr_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_mbFtr_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_mbFtr_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_mbFtr_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_mbFtr_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_mbFtr_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_mbFtr_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			}
		},
		beforeMount() {
			const self_ = this;

			self_.messageState_ = self_.getState('message')
		},
		methods: {
			$_mbFtr_close() {
				const self_ = this;

				self_.setComponentState('showMessagebarFooter', false)

				self_.resetMessageState()
			},
			$_mbFtr_send() {
				const self_ = this;
				const router_ = self_.$router;

				self_.onSending_ = true;

				Promise.resolve().then(() => {
					return self_.storeMessage()
				}).then(() => {
					return self_.$_mbFtr_pushNotification()
				}).then(() => {
					return self_.clearMessageState()
				}).then(() => {
					// sending status
					self_.onSending_ = false;
					// update messages
					router_.push('/timeline/refresh')

					self_.setComponentState('showMessagebarFooter', false)
				}).catch(error => {
/* error */			self_.logError('Error', '$_mbFtr_send()', error)
				})
			},
			$_mbFtr_pushNotification() {
				const self_ = this;

				const toUid_ = self_.getMessageState('toUid')
				const title_ = self_.getMessageState('title')
				const text_ = self_.getMessageState('text')

				return self_.oneSignalPushNotificationByUid(toUid_, title_, text_, null)
			}
		}
	}
</script>

<style scoped>
	.footer_ {
		margin-bottom: 30px !important;
	}
	.row_ {
		min-height: 64px;
	}
	.pretty_ {
		border: none;
	}
</style>
